import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, Output, EventEmitter, ElementRef } from '@angular/core';
import { ScheduleDate, Department, CompanyRef, Uploadable, Contact, Contract, PermanentSavingsLogic, Parameter, ContributionTypesEnum } from '@akiba/models_bimbo';
import { MatTable, MatDialog, MatDatepickerInputEvent, MatCheckboxChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { Moment } from 'moment';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { NgModel } from '@angular/forms';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';

@Component({
  selector: 'app-ps-parameters',
  templateUrl: './ps-parameters.component.html',
  styleUrls: ['./ps-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PsParametersComponent implements OnInit, OnDestroy, OnChanges {

  generalSubscription: Subscription = null;

  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////

  @ViewChild('registrationDatesTable', { static: false }) registrationDatesTable: MatTable<ScheduleDate>;
  @ViewChild('withdrawDatesTable', { static: false }) withdrawDatesTable: MatTable<ScheduleDate>;
  @ViewChild('weeklyMin', { static: false }) weeklyMin: NgModel;
  @ViewChild('biWeeklyMin', { static: false }) biWeeklyMin: NgModel;

  displayedRegistrationDatesColumns: string[] = ['Inicio', 'Fin', 'FinIndeterminado', 'active', 'delete'];
  displayedWithdrawDatesColumns: string[] = ['Inicio', 'Fin', 'active', 'delete'];
  displayedCompanyColumns: string[] = ['companyID', 'companyName', 'taxationIdentificationNumber', 'select'];
  displayedDepartmentColumns: string[] = ['departmentID', 'departmentName', 'select'];
  displayedContractColumns: string[] = ['contractID', 'description', 'select'];

  selectionDepartments: SelectionModel<Department>;
  selectionCompanies: SelectionModel<CompanyRef>;
  selectionContracts: SelectionModel<Contract>;

  appModChangesSubscription: Subscription = null;
  departmentsSubscription: Subscription = null;
  selectionCompaniesSubscription: Subscription = null;
  selectionDepartmentsSubscription: Subscription = null;
  selectionContractSubscription: Subscription = null;
  resetModPeriodSubscription: Subscription = null;

  newRegistrationDate = new ScheduleDate();
  newWithdrawDate = new ScheduleDate();

  revenueAmount: number = 0;
  iRFileLink: string = '';
  iRExecutionDate: string = '';
  iRStatus: string;
  iRFileStatusRef: firebase.database.Reference;

  @ViewChild('statusButton', { static: false }) statusButton: ElementRef;

  @Input() contentLocation: AppState;
  @Input() modParameter: Parameter;

  @Output() hideActionButtons = new EventEmitter<boolean>();

  iRA: number = 0;
  originalDRDistributionValue: boolean;


  constructor(public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService, private uiService: UiService) {

    this.selectionDepartments = new SelectionModel<Department>(true, [], true);
    this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);
    this.selectionContracts = new SelectionModel<Contract>(true, [], true);

    this.generalSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe(p => {

      if (p && p.response) {

        this.doSubscriptions();

      }

    });

    this.logicService.dataManager.generalDataLoader.load();


  }
  ngOnChanges(changes: SimpleChanges): void {
    this.originalDRDistributionValue = this.modParameter.hasDRDistribution;
    this.doSubscriptions();
  }

  ngOnInit() {

  }

  switchTo(anIndex: number) {
    this.contentLocation.savingParametersIndex = anIndex;

    this.hideActionButtons.emit(anIndex === 7);

    if (anIndex === 7) this._updateDRStatus();
  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  detectFiles(event: any, type: string) {

    if (!event.target.files.length) {
      return;
    }

    const file: File = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const aDate = new Date().getTime().toString();
      this.modParameter.savingParameter.fileUploaded = new Uploadable();
      this.modParameter.savingParameter.fileUploaded.bucket = 'files/' + this.modParameter.parametersID + '_' + aDate + '_' + file.name;
      this.modParameter.savingParameter.fileUploaded.name = aDate + '_' + file.name;
      this.modParameter.savingParameter.fileUploaded.file = file;
    };

    reader.readAsDataURL(file);

  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////


  setRegistrationDate(type: string, event: MatDatepickerInputEvent<Moment>) {
    if (type === 'starts') {
      this.newRegistrationDate.startDate = event.value.toDate();
    } else if (type === 'ends') {
      this.newRegistrationDate.endDate = event.value.toDate();
    }
  }

  addRegistrationDate() {

    if (!this.newRegistrationDate.startDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha de inicio es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.isNewDateValid(this.newRegistrationDate)) {

      this.newRegistrationDate.active = true;
      this.modParameter.savingParameter.registrationDates.push(this.newRegistrationDate);

      this.newRegistrationDate = new ScheduleDate();
      this.newRegistrationDate.startDate = null;
      this.newRegistrationDate.endDate = null;

      if (this.registrationDatesTable) {
        this.registrationDatesTable.renderRows();
      }

    } else {

      if (!this.newRegistrationDate.endDate && !this.newRegistrationDate.indeterminate) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'Las fecha de fin de inscripción es requerida si no se especifica como sin fecha fin.',
            close: 'Aceptar'
          }
        });

        return;

      }

    }

  }

  deleteRegistrationDate(index: number) {
    this.modParameter.savingParameter.registrationDates.splice(index, 1);
    this.registrationDatesTable.renderRows();
  }

  setDateAsIndeterminate(event: MatCheckboxChange) {
    if (event.checked) {

      this.newRegistrationDate.endDate = null;
      this.newRegistrationDate.indeterminate = true;

    } else {

      this.newRegistrationDate.endDate = this.newRegistrationDate.startDate;
      this.newRegistrationDate.indeterminate = false;

    }

  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////


  setWithdrawDate(type: string, event: MatDatepickerInputEvent<Moment>) {
    if (type === 'starts') {
      this.newWithdrawDate.startDate = event.value.toDate();
    } else if (type === 'ends') {
      this.newWithdrawDate.endDate = event.value.toDate();
    }
  }

  addWithdrawDate() {

    if (!this.newWithdrawDate.startDate || !this.newWithdrawDate.endDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fechas de inicio y fin de retiro son requeridas.',
          close: 'Aceptar'
        }
      });

      return;

    }

    this.newWithdrawDate.active = true;
    this.modParameter.savingParameter.withdrawDates.push(this.newWithdrawDate);

    this.newWithdrawDate = new ScheduleDate();
    this.newWithdrawDate.startDate = null;
    this.newWithdrawDate.endDate = null;

    if (this.withdrawDatesTable) {
      this.withdrawDatesTable.renderRows();
    }

  }

  deleteWithdrawDate(index: number) {
    this.modParameter.savingParameter.withdrawDates.splice(index, 1);
    this.withdrawDatesTable.renderRows();
  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  reset() {

    this.newRegistrationDate = new ScheduleDate();
    this.newWithdrawDate = new ScheduleDate();

    this.newRegistrationDate.startDate = null;
    this.newRegistrationDate.endDate = null;
    this.newWithdrawDate.startDate = null;
    this.newWithdrawDate.endDate = null;

    this.selectionDepartments.clear();
    this.selectionCompanies.clear();
    this.selectionContracts.clear();

  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  isNewDateValid(aPeriodDate: ScheduleDate): boolean {

    let valid = false;
    if (aPeriodDate.startDate) {
      if (!aPeriodDate.indeterminate) {
        if (aPeriodDate.endDate) {
          valid = true;
        }
      } else if (aPeriodDate.indeterminate) {
        if (!aPeriodDate.endDate) {
          valid = true;
        }
      }
    }

    return valid;

  }

  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////


  doSubscriptions() {

    if (!this.modParameter || !this.modParameter.savingParameter) {
      return;
    }

    if (this.selectionDepartmentsSubscription && !this.selectionDepartmentsSubscription.closed) {
      this.selectionDepartmentsSubscription.unsubscribe();
      this.selectionDepartmentsSubscription = null;
    }

    this.selectionDepartments = new SelectionModel<Department>(true, [], true);

    this.logicService.dataManager.generalDataLoader.departments.forEach(d => {
      const index = this.modParameter.savingParameter.excludedDepartment.map(ed => ed.departmentID).indexOf(d.departmentID);
      if (index >= 0) {
        this.selectionDepartments.select(d);
      }
    });

    this.selectionDepartmentsSubscription = this.selectionDepartments.changed.subscribe(x => {

      if (x.added.length) {

        x.added.forEach(element => {
          const index = this.modParameter.savingParameter.excludedDepartment.findIndex(ed => ed.departmentID === element.departmentID);
          if (index < 0) {
            this.modParameter.savingParameter.excludedDepartment.push(element);
          }

        });

      } else if (x.removed.length) {

        x.removed.forEach(element => {
          const index = this.modParameter.savingParameter.excludedDepartment.findIndex(ed => ed.departmentID === element.departmentID);
          this.modParameter.savingParameter.excludedDepartment.splice(index, 1);
        });

      }

    });

    this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

    this.logicService.dataManager.generalDataLoader.companies.forEach(cr => {
      const index = this.modParameter.savingParameter.includedCompanies.map(ic => ic.companyID).indexOf(cr.companyID);
      if (index >= 0) {
        this.selectionCompanies.select(cr);
      }
    });

    this.selectionCompaniesSubscription = this.selectionCompanies.changed.subscribe(x => {

      if (x.added.length) {

        x.added.forEach(element => {
          const index = this.modParameter.savingParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
          if (index < 0) {
            this.modParameter.savingParameter.includedCompanies.push(element);
          }
        });

      } else if (x.removed.length) {

        x.removed.forEach(element => {
          const index = this.modParameter.savingParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
          this.modParameter.savingParameter.includedCompanies.splice(index, 1);
        });

      }

    });

    this.selectionContracts = new SelectionModel<Contract>(true, [], true);

    if (this.selectionContractSubscription && !this.selectionContractSubscription.closed) {
      this.selectionContractSubscription.unsubscribe();
      this.selectionContractSubscription = null;
    }

    this.logicService.dataManager.generalDataLoader.contracts.forEach(cr => {
      const index = this.modParameter.savingParameter.contractTypes.indexOf(cr.contractID);
      if (index >= 0) {
        this.selectionContracts.select(cr);
      }
    });

    this.selectionContractSubscription = this.selectionContracts.changed.subscribe(x => {

      if (x.added.length) {

        x.added.forEach(element => {
          const index = this.modParameter.savingParameter.contractTypes.findIndex(ic => ic === element.contractID);
          if (index < 0) {
            this.modParameter.savingParameter.contractTypes.push(element.contractID);
          }
        });

      } else if (x.removed.length) {

        x.removed.forEach(element => {
          const index = this.modParameter.savingParameter.contractTypes.findIndex(ic => ic === element.contractID);
          this.modParameter.savingParameter.contractTypes.splice(index, 1);
        });

      }

    });

    if (this.registrationDatesTable) {
      this.registrationDatesTable.renderRows();
    }

    if (this.withdrawDatesTable) {
      this.withdrawDatesTable.renderRows();
    }



  }

  cancelSubscriptions() {

    if (this.generalSubscription && !this.generalSubscription.closed) {
      this.generalSubscription.unsubscribe();
      this.generalSubscription = null;
    }

    if (this.departmentsSubscription && !this.departmentsSubscription.closed) {
      this.departmentsSubscription.unsubscribe();
      this.departmentsSubscription = null;
    }

    if (this.appModChangesSubscription && !this.appModChangesSubscription.closed) {
      this.appModChangesSubscription.unsubscribe();
      this.appModChangesSubscription = null;
    }

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

    if (this.selectionDepartmentsSubscription && !this.selectionDepartmentsSubscription.closed) {
      this.selectionDepartmentsSubscription.unsubscribe();
      this.selectionDepartmentsSubscription = null;
    }

    if (this.resetModPeriodSubscription && !this.resetModPeriodSubscription.closed) {
      this.resetModPeriodSubscription.unsubscribe();
      this.resetModPeriodSubscription = null;
    }

  }

  ngOnDestroy(): void {

    this.cancelSubscriptions();

  }

  cancelInvestmentReturn(rejection: boolean = false) {

    this.revenueAmount = 0;
    if (rejection) {
      const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, { data: {
        message: '¿Está seguro que desea descartar la distribución de réditos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }})

      dialogConfirmation.afterClosed().subscribe(async result => {
        if (result) {

          this.uiService.showSpinner();
          const response = await this.dataService.rejectInvestmentReturn(ContributionTypesEnum.CAL);

          this.uiService.stopSpinner();

          this.dialog.open(InfoDialogComponent, { data: {
            message: 'Cálculo de rendimiento eliminado',
            close: 'Aceptar'
          }});

        }
      });
    } else {
      this.switchTo(0);
    }
  }

  async calculateDR() {
    try {

      if (typeof this.revenueAmount !== 'number') {
        this.dialog.open(InfoDialogComponent, { data: {
          message: 'El dato ingresado es inválido. Inténtelo nuevamente',
          close: 'Aceptar'
        }});

        return;
      }

      this.uiService.showSpinner();

      this.revenueAmount = Number(this.revenueAmount);

      const companyIDs: string[] = this.modParameter.savingParameter.includedCompanies.map(c => c.companyID);
      const response = await this.dataService.createDRFile(companyIDs, ContributionTypesEnum.CAL, Number(this.revenueAmount));

      this.uiService.stopSpinner();
  
      this.dialog.open(InfoDialogComponent, { data: {
        message: 'Se inició correctamente la generación del archivo de validación',
        close: 'Aceptar'
      }});

      this.iRFileLink = '';
      
    } catch (error) {
      this.dialog.open(InfoDialogComponent, { data: {
        message: 'Ocurrió un error al intentar generar el archivo de validación',
        close: 'Aceptar'
      }});
      console.log(error);
    }
  }

  async getDRValidationFile() {
    this.uiService.showSpinner();
    const status: any = await this.dataService.getInvestmentReturnValidationFile(ContributionTypesEnum.CAL);

    if (!status.result) {
      this.uiService.stopSpinner();
    } else {

      if (status.result[Object.keys(status.result)[0]]['url']) {
        this.iRExecutionDate = Object.keys(status.result)[0];
        this.iRFileLink = status.result[Object.keys(status.result)[0]]['url'];
      } else {
        this.iRFileLink = '';
      }
      
      this.uiService.stopSpinner();
    }
  }

  downloadIRFile() {
    window.open(this.iRFileLink);
  }

  async distributeDR() {
    try {

      const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, { data: {
        message: '¿Está seguro que desea iniciar la distribución de rendimientos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }})

      dialogConfirmation.afterClosed().subscribe(async result => {
        if (result) {

          this.uiService.showSpinner();
          
         const response = await this.dataService.distributeDR(ContributionTypesEnum.CAL, this.iRExecutionDate).catch(async error => {
          console.log('error', error);
        });
      
          this.uiService.stopSpinner();
    
          this.dialog.open(InfoDialogComponent, { data: {
            message: 'Se inició correctamente la distribución de los rendimientos',
            close: 'Aceptar'
          }});

        } else {
          console.log('Cancelada')
        }
      });
      
    } catch (error) {
      console.log('Error al distribuir', error);

    }
  }

  private _updateDRStatus() {
    this.iRFileStatusRef = this.dataService.checkInvestmentReturnStatus(ContributionTypesEnum.CAL);
    this.iRFileStatusRef.child('status').on('value', async (snapshot: firebase.database.DataSnapshot) => {
      
      // this.uiService.showSpinner();
      
      this.iRStatus = snapshot.val();

      if (this.iRStatus === 'fileCreated') {
        await this.getDRValidationFile();
      }

      this.statusButton.nativeElement.click();

      // this.uiService.stopSpinner();
      
    });
  }

  changeStatus() {
    this.iRStatus = this.iRStatus;
  }

}
